import { useFormik } from "formik";
import React from "react";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { login } from "../../Services/AuthService";

const validationSchema = yup.object({
  email: yup.string().email().required("This field is required..."),
  password: yup.string().required("This field is required..."),
});

export const Login = () => {
  const [submitting, setSubmitting] = React.useState(false);
  const loggedIn = useSelector((x) => x.LoggedIn);
  const userType = useSelector((x) => x.UserType);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (loggedIn) navigate(location.state?.from || "/store", { replace: true });
  }, [loggedIn]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: (v) => {
      setSubmitting(true);
      login(v).then(
        (res) => {
          setSubmitting(false);
          dispatch({ type: "setToken", payload: res.token });
          dispatch({ type: "setStore", payload: res.data });
          dispatch({ type: "setLoggedIn", payload: true });
          dispatch({ type: "setRole", payload: "store" });
        },
        (err) => {
          setSubmitting(false);
          // if (errors?.length > 0) {
          //   errors.forEach((z) => {
          toast.error(err.error, { autoClose: 5000 });
          //   });
          // }
        }
      );
    },
  });

  return (
    <>
      <div className="container-fluid sign-up-form bg-white">
        <div className="row" style={{ minHeight: "100vh" }}>
          <div className="col-md-7 col-12">
            <div className="row">
              <div className="col-12 p-4 d-flex justify-content-center justify-content-md-start">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                  alt=""
                  style={{ width: "198px", height: "33px" }}
                />
              </div>
              <div
                style={{ height: "calc(85vh - 65px)" }}
                className="col-12 d-flex justify-content-center flex-column align-items-center"
              >
                <form
                  className="col-lg-6 col-md-8 col-11"
                  onSubmit={formik.handleSubmit}
                >
                  <div>
                    <span
                      style={{
                        fontSize: "35px",
                        display: "block",
                        color: "#232323",
                      }}
                      className="fw-bold"
                    >
                      Sign In
                    </span>
                    <span
                      style={{
                        fontSize: "18px",
                        display: "block",
                        color: "#969696",
                      }}
                    >
                      Please login to continue to your account.
                    </span>
                  </div>
                  <Form.Group className="mb-3 mt-4" controlId="email">
                    <Form.Control
                      type="email"
                      name="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Email"
                    />
                    {Boolean(formik.errors.email) && formik.touched.email ? (
                      <Form.Text className="text-danger d-block">
                        {formik.errors.email}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="password">
                    <Form.Control
                      type="password"
                      name="password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Password"
                    />
                    {Boolean(formik.errors.password) &&
                    formik.touched.password ? (
                      <Form.Text className="text-danger d-block">
                        {formik.errors.password}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <button className="login-btn" type="submit">
                    {submitting ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    ) : null}
                    Login
                  </button>
                  {/* <small className="text-center my-4 d-block">
                    <Link
                      className="ms-1 fw-semibold app-text-primary"
                      to="/store/forgot-password"
                      style={{ textDecoration: "none" }}
                    >
                      Forgot Password?
                    </Link>
                  </small>
                  <small className="text-center mb-4 d-block">
                    Don't have an account?{" "}
                    <Link
                      className="ms-1 fw-semibold app-text-primary"
                      to="/store/sign-up"
                      style={{ textDecoration: "none" }}
                    >
                      Sign-up
                    </Link>
                  </small>

                  {userType != false ? (
                    <>
                      <div className="div position-relative">
                        <hr className="border-2" />
                        <div
                          className="position-absolute w-100 text-center"
                          style={{ top: "-13px" }}
                        >
                          <small
                            className="px-2 fw-semibold text-muted"
                            style={{ backgroundColor: "#fff" }}
                          >
                            OR
                          </small>
                        </div>
                      </div>
                      <small className="text-center my-4 pb-2 d-block">
                        <span
                          className="ms-1 fw-semibold app-text-primary text-uppercase cursor-pointer"
                          onClick={() => {
                            dispatch({ type: "setUserType", payload: false });
                            navigate("/store");
                          }}
                        >
                          Continue as Guest
                        </span>
                      </small>
                    </>
                  ) : null} */}
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-5 d-none d-md-block py-2">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/img_react_signin.jpg"}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
                maxHeight: "95vh",
                borderRadius: "24px",
                backgroundColor: "#aaa",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
